const state = {
  all: []
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchAll ({ dispatch, commit }, data) {
    commit('setAll', data)
  }
}

const mutations = {
  cleanState (state) {
    state.all = []
  },

  setAll (state, data) {
    state.all = data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}